// React Imports
import React, { useEffect, useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports

import AddAcademyParticipantDialog from "./AddAcademyParticipantDialog";

import DeleteAcademyDocumentFolderDialog from "./DeleteAcademyDocumentFolderDialog";
import { IAcademyDocumentFolder } from "../../Models/IAcademyDocumentFolder";
import AddMediathekDocumentDialog from "../Mediathek/AddMediathekDocumentDialog";
import AddAcademyDocumentDialog from "./AddAcademyDocumentDialog";
import { Button } from "@fluentui/react-components";
import {
  ArrowUploadRegular,
  DeleteRegular,
  DocumentAddRegular,
  DocumentCopyRegular,
  EditRegular,
  PeopleAddRegular,
} from "@fluentui/react-icons";
import { IAcademyDocumentFolder2UserDocument } from "../../Models/IAcademyDocumentFolder2UserDocument";
import { IAppUserDto } from "../../Models/IAppUserDto";
import { useNavigate } from "react-router-dom";

// Props
interface IAcademyDocumentFolderCommandBarProps {
  allUsers: IAppUserDto[];
  academyFolder: IAcademyDocumentFolder;
  onRefreshRequested: any;
  onCopyRequested: any;
  onUpdateRequested: any;
}

// Function
function AcademyDocumentFolderCommandBar(
  props: IAcademyDocumentFolderCommandBarProps,
) {
  const [addAcademyParticipantIsOpen, setAddAcademyParticipantIsOpen] =
    useState<boolean>(false);
  const [addAcademyDocumentIsOpen, setAddAcademyDocumentIsOpen] =
    useState<boolean>(false);
  const [deleteAcademyFolderIsOpen, setDeleteAcademyFolderIsOpen] =
    useState<boolean>(false);
  const [uploadFileIsOpen, setUploadFileIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  // const _commandBarItems: ICommandBarItemProps[] = [
  //   {
  //     key: "document",
  //     text: i18n.t<string>("addAcademyDocument"),
  //     iconProps: { iconName: "Add" },
  //     subMenuProps: {
  //       items: [
  //         {
  //           key: "addAcademyDocument",
  //           text: i18n.t<string>("addAcademyDocument"),
  //           iconProps: { iconName: "PageAdd" },
  //           onClick: () => {
  //             setAddAcademyDocumentIsOpen(true);
  //           },
  //         },
  //         {
  //           key: "uploadFile",
  //           text: i18n.t<string>("uploadFile"),
  //           iconProps: { iconName: "Upload" },
  //           onClick: () => {
  //             setUploadFileIsOpen(true);
  //           },
  //         },
  //       ],
  //     },
  //   },

  //   {
  //     disabled: props.allUsers.length == 0,
  //     key: "addAcademyParticipant",
  //     text: i18n.t<string>("addAcademyParticipant"),
  //     iconProps: { iconName: "AddGroup" },
  //     onClick: () => {
  //       setAddAcademyParticipantIsOpen(true);
  //     },
  //   },
  //   {
  //     key: "updateAcademyFolder",
  //     text: i18n.t<string>("updateAcademyFolderDialogTitle"),
  //     iconProps: { iconName: "Edit" },
  //     onClick: () => {
  //       props.onUpdateRequested();
  //     },
  //   },
  //   {
  //     key: "copyAcademyFolder",
  //     text: i18n.t<string>("copyAcademyFolder"),
  //     iconProps: { iconName: "Copy" },
  //     onClick: () => {
  //       props.onCopyRequested();
  //     },
  //   },
  //   {
  //     key: "removeAcademyFolder",
  //     text: i18n.t<string>("removeAcademyFolder"),
  //     iconProps: { iconName: "Delete" },
  //     onClick: () => {
  //       setDeleteAcademyFolderIsOpen(true);
  //     },
  //   },
  // ];

  return (
    <div>
      {addAcademyParticipantIsOpen && props.academyFolder.guid && (
        <AddAcademyParticipantDialog
          academyDocumentFolder2AppUsersIDs={
            props.academyFolder.academyDocumentFolder2AppUsers
              ? props.academyFolder.academyDocumentFolder2AppUsers
              : []
          }
          allUsers={props.allUsers}
          isDialogOpen={addAcademyParticipantIsOpen}
          onDismiss={() => {
            props.onRefreshRequested();
            setAddAcademyParticipantIsOpen(false);
          }}
          academyDocumentFolderGuid={props.academyFolder.guid}
        />
      )}

      {props.academyFolder.guid && (
        <AddAcademyDocumentDialog
          academyDocumentFolder2UserDocuments={props.academyFolder.academyDocumentFolder2UserDocuments?.map(
            (item: IAcademyDocumentFolder2UserDocument) => {
              return item.userDocumentGuid;
            },
          )}
          folderGuid={props.academyFolder.guid}
          isDialogOpen={addAcademyDocumentIsOpen}
          onDismiss={() => {
            props.onRefreshRequested();
            setAddAcademyDocumentIsOpen(false);
          }}
        />
      )}

      {deleteAcademyFolderIsOpen && (
        <DeleteAcademyDocumentFolderDialog
          isDialogOpen={deleteAcademyFolderIsOpen}
          onDelete={() => {
            props.onRefreshRequested();
            setDeleteAcademyFolderIsOpen(false);
            navigate("/academyadmin");
          }}
          onDismiss={() => setDeleteAcademyFolderIsOpen(false)}
          academyFolder={props.academyFolder}
        />
      )}

      {
        <AddMediathekDocumentDialog
          academyDocumentFolderGuid={props.academyFolder.guid}
          isDialogOpen={uploadFileIsOpen}
          onDismiss={() => {
            props.onRefreshRequested();
            setUploadFileIsOpen(false);
          }}
        />
      }

      <div>
        <Button
          icon={<DocumentAddRegular />}
          appearance="subtle"
          onClick={() => {
            setAddAcademyDocumentIsOpen(true);
          }}
        >
          {i18n.t<string>("addAcademyDocument")}
        </Button>

        <Button
          icon={<ArrowUploadRegular />}
          appearance="subtle"
          onClick={() => {
            setUploadFileIsOpen(true);
          }}
        >
          {i18n.t<string>("uploadFile")}
        </Button>

        <Button
          icon={<PeopleAddRegular />}
          appearance="subtle"
          disabled={props.allUsers.length == 0}
          onClick={() => {
            setAddAcademyParticipantIsOpen(true);
          }}
        >
          {i18n.t<string>("addAcademyParticipant")}
        </Button>

        <Button
          icon={<EditRegular />}
          appearance="subtle"
          onClick={() => {
            props.onUpdateRequested();
          }}
        >
          {i18n.t<string>("updateAcademyFolderDialogTitle")}
        </Button>

        <Button
          icon={<DocumentCopyRegular />}
          appearance="subtle"
          onClick={() => {
            props.onCopyRequested();
          }}
        >
          {i18n.t<string>("copyAcademyFolder")}
        </Button>

        <Button
          icon={<DeleteRegular />}
          appearance="subtle"
          onClick={() => {
            setDeleteAcademyFolderIsOpen(true);
          }}
        >
          {i18n.t<string>("removeAcademyFolder")}
        </Button>
      </div>
    </div>
  );
}

// Export Function
export default AcademyDocumentFolderCommandBar;
